import React from "react";
import styles from "../education/educationbots.module.css";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// icons
import admissionIcon from "../../asset/admission.png";
import classIcon from "../../asset/myclass.png";

const educationBots = [
  {
    title: "Admission",
    desc: "Manage student admissions seamlessly.",
    img: admissionIcon,
    color: "#00d4ff",
    tags: ["AI Assistant", "Automated"],
  },
  {
    title: "My Class",
    desc: "View and manage class schedules and resources.",
    img: classIcon,
    color: "#9333ea",
    tags: ["Smart", "Organized"],
  },
];

const EducationBot = ({ onBack }) => {
  const navigate = useNavigate();
  const [hoveredCard, setHoveredCard] = React.useState(null);

  return (
    <div className={styles.container}>
      {/* Tech Background Elements */}
      <div className={styles.techBg}></div>
      <div className={styles.floatingElements}>
        {[...Array(4)].map((_, i) => (
          <div key={i} className={styles.floatingElement}></div>
        ))}
      </div>

      {/* Header Section */}
      <div className={styles.header}>
        <div className={styles.titleContainer}>
          {/* <span className={styles.titleIcon}>🏫</span> */}
          <h2 className={styles.heading}>Education AI Assistant</h2>
          <span className={styles.titleGlow}></span>
        </div>
        <p className={styles.subtitle}>
          Specialized AI solutions for educational institutions
        </p>
        <div className={styles.headerLine}></div>
      </div>

      {/* Status Indicator */}
      <div className={styles.statusContainer}>
        <div className={styles.statusIndicator}>
          <span className={styles.statusDot}></span>
          <span className={styles.statusText}>AI Models Active</span>
        </div>
        <div className={styles.techBadge}>EDUCATION BETA</div>
      </div>

      {/* Cards Grid */}
      <div className={styles.grid}>
        {educationBots.map((bot, index) => (
          <motion.div
            key={bot.title}
            className={styles.card}
            onMouseEnter={() => setHoveredCard(bot.title)}
            onMouseLeave={() => setHoveredCard(null)}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2 }}
            whileHover={{ y: -5 }}
            style={{ "--card-color": bot.color }}
          >
            {/* Card Glow Effect */}
            <div
              className={styles.cardGlow}
              style={{ opacity: hoveredCard === bot.title ? 1 : 0 }}
            ></div>

            {/* Card Border */}
            <div className={styles.cardBorder}></div>

            {/* Top Row with Icon */}
            <div className={styles.topRow}>
              <div className={styles.iconContainer}>
                <div
                  className={styles.iconGlow}
                  style={{
                    background: `radial-gradient(circle, ${bot.color}40, transparent 70%)`,
                  }}
                />
                <div className={styles.iconBox}>
                  <div className={styles.emojiIcon}>{bot.icon}</div>
                  <img
                    src={bot.img}
                    alt={bot.title}
                    className={styles.cardImg}
                  />
                </div>
              </div>

              {/* Text Content */}
              <div className={styles.textBlock}>
                <div className={styles.cardHeader}>
                  <h3>{bot.title}</h3>
                  {/* <span className={styles.cardBadge}>AI</span> */}
                </div>

                <p className={styles.textBlock1}>{bot.desc}</p>
              </div>
            </div>

            {/* Try Demo Button */}
            <motion.button
              className={styles.button}
              onClick={() => navigate("/comingsoon")}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              <span className={styles.btnIcon}>▶</span>
              Explore Demo
            </motion.button>

            {/* Connection Points */}
            <div className={styles.connectionPoints}>
              <div className={styles.connectionPoint}></div>
              <div className={styles.connectionPoint}></div>
              <div className={styles.connectionPoint}></div>
            </div>
          </motion.div>
        ))}
      </div>

      {/* Bottom Center Back Button */}
      <div className={styles.bottomAction}>
        <motion.button
          className={styles.bottomButton}
          onClick={onBack}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          <span className={styles.bottomIcon}>←</span>
          Return to Dashboard
          <div className={styles.bottomGlow}></div>
        </motion.button>
      </div>

      {/* Bottom Tech Elements */}
      <div className={styles.bottomTech}>
        <div className={styles.dataStream}></div>
        <div className={styles.techNote}>
          <span className={styles.noteIcon}>⚡</span>
          <span>Powered by Neural AI Education Models</span>
        </div>
      </div>
    </div>
  );
};

export default EducationBot;
